import { ReactComponent as Show } from 'assets/icons/icon-show.svg';

export default Show;
